import { error } from '@sveltejs/kit';
import type { PageLoad } from './$types';
import { getLeaderboard } from '$lib/api/studentActions';

export const load: PageLoad = ({ params, parent, fetch }) => {
  const id = parseInt(params.id);
  if (isNaN(id)) error(404);
  const leaderboardPromise = getLeaderboard(id, fetch);
  return {
    leaderboardPromise,
    meta: {
      title: 'Classes',
      breadcrumbs: {
        activeTitle: parent()
          .then(x => x.classPromise)
          .then(x => x.class.name),
        items: [
          {
            title: 'Classes',
            href: '/classes',
          },
        ],
      },
    },
  };
};
